import React, { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Divider,
  Chip,
  Button,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  InputAdornment,
  Menu,
  MenuItem,
  IconButton,
  Tooltip,
  CircularProgress,
  Avatar,
  Paper,
  useMediaQuery,
} from '@mui/material';
import {
  People,
  Business,
  Payment,
  Description,
  Search,
  MoreVert,
  CheckCircle,
  Pending,
  Warning,
  BarChart,
  Receipt,
  Settings,
  Storefront,
  ArrowForward,
  ArrowBack,
  AccountCircle,
} from '@mui/icons-material';
import { getUsers, isAuthenticated } from '../../../network/auth';
import { useNavigate } from 'react-router-dom';
import { getAllCompanies } from '../../../network/company';
import CompanyDetailDialog from '../company_details_dialog';

const dummyCompanies = [
  {
    UpdatedAt: '2025-05-02T22:04:39.790Z',
    AccountsDueDate: '2027-02-02',
    RegisteredAddress: {
      country: 'United Kingdom',
      isPublic: true,
      city: 'London',
      street: '1 Tech Park',
      postalCode: 'SW1A 1AA',
    },
    CompanyNumber: 'COMP10417949',
    Status: 'ACTIVE',
    Tax: {
      corporationTaxRegistered: false,
      vatRegistered: false,
      payeRegistered: false,
    },
    ComplianceTimeline: [
      {
        due: '2026-05-02',
        penalty: '£250 to £1,500 if late',
        description: 'Annual statement confirming company details',
        legalRequirement: true,
        id: 'f19c8ec3-ac6f-4e1a-be08-93f0236b9189',
        category: 'legal',
        priority: 'high',
        title: 'File Confirmation Statement (CS01)',
        status: 'completed',
      },
      {
        due: '2027-02-02',
        penalty: '£150 to £1,500 if late',
        description: 'First accounts due 21 months after incorporation',
        legalRequirement: true,
        id: '900ea1d6-f303-4e3e-8b45-c08e933355dd',
        category: 'financial',
        priority: 'high',
        title: 'File First Accounts (AA01)',
        status: 'pending',
      },
      {
        due: 'Not started trading',
        penalty: 'Potential fines + backdated tax',
        description:
          'Must register within 3 months of starting business activity',
        legalRequirement: true,
        id: '0714855a-1fab-4c71-8b27-27c9783a1691',
        category: 'tax',
        priority: 'high',
        title: 'Register for Corporation Tax (CT41G)',
        status: 'not-applicable',
      },
      {
        due: '',
        penalty: 'Fines + backdated VAT if late',
        description: 'Required if taxable turnover exceeds £90,000',
        legalRequirement: false,
        id: '91502bbc-1806-4174-9840-bbe8e8b2948d',
        category: 'tax',
        priority: 'conditional',
        title: 'VAT Registration',
        status: 'not-applicable',
      },
      {
        due: '',
        penalty: 'Fines if late',
        description: 'Required if employing staff or paying directors',
        legalRequirement: false,
        id: '7a781bdb-0a81-4c7e-985a-1970e223c8d9',
        category: 'payroll',
        priority: 'conditional',
        title: 'PAYE Registration',
        status: 'not-applicable',
      },
    ],
    CompanyName: 'Tech Innovations Ltd',
    IncorporationDate: '2025-05-02',
    ConfirmationDueDate: '2026-05-02',
    CompanyType: 'Private Limited Company',
    ShareStructure: {
      shareClasses: [
        {
          currency: 'GBP',
          votingRights: true,
          type: 'ordinary',
          valuePerShare: 1,
          totalShares: 100,
        },
      ],
      statementOfCapital: {
        totalAmount: 100,
        totalShares: 100,
      },
    },
    Officers: {
      secretaries: [],
      directors: [
        {
          role: 'director',
          nationality: 'British',
          name: 'John Smith',
          serviceAddress: {
            city: 'London',
            street: '1 Tech Park',
            postalCode: 'SW1A 1AA',
          },
          dateOfBirth: '1980-05-15',
          id: 'dir_e4c86494-51e9-4452-9e26-379dd6f7ea2e',
          appointedOn: '2025-05-02',
        },
      ],
    },
    CreatedAt: '2025-05-02T22:04:39.790Z',
    SICCodes: ['62012', '62020'],
    UserId: 'e6429264-a051-7038-ccb5-aa02b1c15362',
    CompanyId: 'COMP10417949',
  },
  {
    UpdatedAt: '2025-05-02T22:10:14.888Z',
    AccountsDueDate: '2027-02-02',
    RegisteredAddress: {
      country: 'United Kingdom',
      isPublic: true,
      city: 'Manchester',
      street: '100 Professional Avenue',
      postalCode: 'M2 3AB',
    },
    CompanyNumber: 'COMP974723CB',
    Status: 'ACTIVE',
    Tax: {
      corporationTaxRegistered: false,
      vatRegistered: false,
      payeRegistered: false,
    },
    ComplianceTimeline: [
      {
        due: '2026-05-02',
        penalty: '£250 to £1,500 if late',
        description: 'Annual statement confirming company details',
        legalRequirement: true,
        id: 'ee771107-8380-4351-8ca0-efaef3d0da24',
        title: 'File Confirmation Statement (CS01)',
        category: 'legal',
        priority: 'high',
        status: 'pending',
      },
      {
        due: '2027-02-02',
        penalty: '£150 to £1,500 if late',
        description: 'First accounts due 21 months after incorporation',
        legalRequirement: true,
        id: 'e88aac00-3d0c-423b-86d7-69b89765b35d',
        title: 'File First Accounts (AA01)',
        category: 'financial',
        priority: 'high',
        status: 'pending',
      },
      {
        due: 'Not started trading',
        penalty: 'Potential fines + backdated tax',
        description:
          'Must register within 3 months of starting business activity',
        legalRequirement: true,
        id: '70932631-c862-4d89-9b7a-2ef804bf4185',
        title: 'Register for Corporation Tax (CT41G)',
        category: 'tax',
        priority: 'high',
        status: 'not-applicable',
      },
      {
        due: '',
        penalty: 'Fines + backdated VAT if late',
        description: 'Required if taxable turnover exceeds £90,000',
        legalRequirement: false,
        id: '3404aad4-b231-4177-94f2-37ef3ca9280f',
        title: 'VAT Registration',
        category: 'tax',
        priority: 'conditional',
        status: 'not-applicable',
      },
      {
        due: '',
        penalty: 'Fines if late',
        description: 'Required if employing staff or paying directors',
        legalRequirement: false,
        id: '9bd333d9-5934-4a2c-a25f-909fc10e00dd',
        title: 'PAYE Registration',
        category: 'payroll',
        priority: 'conditional',
        status: 'not-applicable',
      },
    ],
    CompanyName: 'Elite Consultants LLP',
    IncorporationDate: '2025-05-02',
    ConfirmationDueDate: '2026-05-02',
    CompanyType: 'Limited Liability Partnership',
    ShareStructure: {
      shareClasses: [
        {
          currency: 'GBP',
          votingRights: true,
          type: 'ordinary',
          valuePerShare: 1,
          totalShares: 100,
        },
      ],
      statementOfCapital: {
        totalAmount: 100,
        totalShares: 100,
      },
    },
    Officers: {
      secretaries: [
        {
          name: 'Admin Services Ltd',
          serviceAddress: {
            city: 'Manchester',
            street: '100 Professional Avenue',
            postalCode: 'M2 3AB',
          },
          role: 'secretary',
          id: 'sec_80cf2905-83b6-4bda-aae5-894e54c64155',
          appointedOn: '2025-05-02',
        },
      ],
      directors: [
        {
          role: 'director',
          occupation: 'Accountant',
          nationality: 'British',
          name: 'Sarah Johnson',
          serviceAddress: {
            city: 'Manchester',
            street: '100 Professional Avenue',
            postalCode: 'M2 3AB',
          },
          dateOfBirth: '1978-03-10',
          id: 'dir_9a12b7c5-7677-4bb9-b774-16f2faed1fd6',
          appointedOn: '2025-05-02',
        },
        {
          role: 'director',
          occupation: 'Tax Advisor',
          nationality: 'British',
          name: 'Michael Brown',
          serviceAddress: {
            city: 'Manchester',
            street: '100 Professional Avenue',
            postalCode: 'M2 3AB',
          },
          dateOfBirth: '1982-07-25',
          id: 'dir_9fc27206-7314-4a4a-a5e2-28edd1058b55',
          appointedOn: '2025-05-02',
        },
      ],
    },
    CreatedAt: '2025-05-02T22:10:14.888Z',
    SICCodes: ['69201'],
    UserId: 'e6429264-a051-7038-ccb5-aa02b1c15362',
    CompanyId: 'COMP974723CB',
  },
  {
    UpdatedAt: '2025-05-02T22:10:53.148Z',
    AccountsDueDate: '2027-02-02',
    RegisteredAddress: {
      country: 'United Kingdom',
      isPublic: true,
      city: 'Birmingham',
      street: 'Unit 5 Digital Park',
      postalCode: 'B1 2AB',
    },
    CompanyNumber: 'COMP98797B68',
    Status: 'ACTIVE',
    Tax: {
      corporationTaxRegistered: false,
      vatRegistered: false,
      payeRegistered: false,
    },
    ComplianceTimeline: [
      {
        due: '2026-05-02',
        penalty: '£250 to £1,500 if late',
        description: 'Annual statement confirming company details',
        legalRequirement: true,
        id: '5fa040c4-337f-413d-a4ae-bdddcaded5cc',
        title: 'File Confirmation Statement (CS01)',
        category: 'legal',
        priority: 'high',
        status: 'pending',
      },
      {
        due: '2027-02-02',
        penalty: '£150 to £1,500 if late',
        description: 'First accounts due 21 months after incorporation',
        legalRequirement: true,
        id: '06007cfe-ea91-447f-addf-f21f5c8f6ae6',
        title: 'File First Accounts (AA01)',
        category: 'financial',
        priority: 'high',
        status: 'pending',
      },
      {
        due: '2024-04-15',
        penalty: 'Potential fines + backdated tax',
        description:
          'Must register within 3 months of starting business activity',
        legalRequirement: true,
        id: 'ba87fd27-d389-4439-9a89-d2e167196da9',
        title: 'Register for Corporation Tax (CT41G)',
        category: 'tax',
        priority: 'high',
        status: 'pending',
      },
      {
        due: '',
        penalty: 'Fines + backdated VAT if late',
        description: 'Required if taxable turnover exceeds £90,000',
        legalRequirement: false,
        id: '9e7ec204-b858-4227-b79b-a3606cab8023',
        title: 'VAT Registration',
        category: 'tax',
        priority: 'conditional',
        status: 'not-applicable',
      },
      {
        due: '',
        penalty: 'Fines if late',
        description: 'Required if employing staff or paying directors',
        legalRequirement: false,
        id: '3f7fca5a-8bf7-49ca-b37d-3708c4e0f760',
        title: 'PAYE Registration',
        category: 'payroll',
        priority: 'conditional',
        status: 'not-applicable',
      },
    ],
    CompanyName: 'Online Retail UK Ltd',
    IncorporationDate: '2025-05-02',
    ConfirmationDueDate: '2026-05-02',
    CompanyType: 'Private Limited Company',
    ShareStructure: {
      shareClasses: [
        {
          currency: 'GBP',
          votingRights: true,
          type: 'ordinary',
          valuePerShare: 1,
          totalShares: 100,
        },
      ],
      statementOfCapital: {
        totalAmount: 100,
        totalShares: 100,
      },
    },
    Officers: {
      secretaries: [
        {
          name: 'Digital Nomads Ltd',
          serviceAddress: 'same',
          role: 'secretary',
          id: 'sec_83226a0b-8d60-426f-8e50-7d6451c197f8',
          appointedOn: '2025-05-02',
        },
      ],
      directors: [
        {
          role: 'director',
          nationality: 'Chinese',
          name: 'Emma Zhang',
          serviceAddress: 'same',
          dateOfBirth: '1992-09-05',
          id: 'dir_2db7a614-d711-4e38-b918-73f2c81b431b',
          appointedOn: '2025-05-02',
        },
        {
          role: 'director',
          nationality: 'British',
          name: 'James Wilson',
          serviceAddress: 'same',
          dateOfBirth: '1988-12-12',
          id: 'dir_989ab57c-d83d-42ef-8dd1-044206fe3dbb',
          appointedOn: '2025-05-02',
        },
      ],
    },
    CreatedAt: '2025-05-02T22:10:53.148Z',
    SICCodes: ['47910'],
    UserId: 'e6429264-a051-7038-ccb5-aa02b1c15362',
    CompanyId: 'COMP98797B68',
  },
  {
    UpdatedAt: '2025-05-02T22:11:32.146Z',
    AccountsDueDate: '2027-02-02',
    RegisteredAddress: {
      country: 'United Kingdom',
      isPublic: true,
      city: 'Birmingham',
      street: 'Unit 5 Digital Park',
      postalCode: 'B1 2AB',
    },
    CompanyNumber: 'COMPA6CCE99B',
    Status: 'ACTIVE',
    Tax: {
      corporationTaxRegistered: false,
      vatRegistered: false,
      payeRegistered: false,
    },
    ComplianceTimeline: [
      {
        due: '2026-05-02',
        penalty: '£250 to £1,500 if late',
        description: 'Annual statement confirming company details',
        legalRequirement: true,
        id: '7ffcb767-83c4-4708-a7d8-28267e96c883',
        title: 'File Confirmation Statement (CS01)',
        category: 'legal',
        priority: 'high',
        status: 'pending',
      },
      {
        due: '2027-02-02',
        penalty: '£150 to £1,500 if late',
        description: 'First accounts due 21 months after incorporation',
        legalRequirement: true,
        id: '7ccb5781-5e04-4161-ba67-a9e062cfb865',
        title: 'File First Accounts (AA01)',
        category: 'financial',
        priority: 'high',
        status: 'pending',
      },
      {
        due: '2024-04-15',
        penalty: 'Potential fines + backdated tax',
        description:
          'Must register within 3 months of starting business activity',
        legalRequirement: true,
        id: '7e25c005-16c8-4dae-890f-ac56231b9e6e',
        title: 'Register for Corporation Tax (CT41G)',
        category: 'tax',
        priority: 'high',
        status: 'pending',
      },
      {
        due: '',
        penalty: 'Fines + backdated VAT if late',
        description: 'Required if taxable turnover exceeds £90,000',
        legalRequirement: false,
        id: '8e43857c-3cd3-4931-b5f4-363e4eea3359',
        title: 'VAT Registration',
        category: 'tax',
        priority: 'conditional',
        status: 'not-applicable',
      },
      {
        due: '',
        penalty: 'Fines if late',
        description: 'Required if employing staff or paying directors',
        legalRequirement: false,
        id: 'faab0405-4321-4a42-9865-0954ab6230ac',
        title: 'PAYE Registration',
        category: 'payroll',
        priority: 'conditional',
        status: 'not-applicable',
      },
    ],
    CompanyName: 'Universal Retail UK Ltd',
    IncorporationDate: '2025-05-02',
    ConfirmationDueDate: '2026-05-02',
    CompanyType: 'Private Limited Company',
    ShareStructure: {
      shareClasses: [
        {
          currency: 'GBP',
          votingRights: true,
          type: 'ordinary',
          valuePerShare: 1,
          totalShares: 100,
        },
      ],
      statementOfCapital: {
        totalAmount: 100,
        totalShares: 100,
      },
    },
    Officers: {
      secretaries: [
        {
          name: 'Digital Nomads Ltd',
          serviceAddress: 'same',
          role: 'secretary',
          id: 'sec_f651d727-d55c-424b-b829-2a95a6060819',
          appointedOn: '2025-05-02',
        },
      ],
      directors: [
        {
          role: 'director',
          nationality: 'Chinese',
          name: 'Emma Zhang',
          serviceAddress: 'same',
          dateOfBirth: '1992-09-05',
          id: 'dir_33e86ce7-460d-46a6-ab1c-eae56857d881',
          appointedOn: '2025-05-02',
        },
        {
          role: 'director',
          nationality: 'British',
          name: 'James Wilson',
          serviceAddress: 'same',
          dateOfBirth: '1988-12-12',
          id: 'dir_79204c6e-e54a-428b-8bad-eda99cad6fda',
          appointedOn: '2025-05-02',
        },
      ],
    },
    CreatedAt: '2025-05-02T22:11:32.146Z',
    SICCodes: ['47910'],
    UserId: '66a242e4-4021-70b1-28b2-376636391fd4',
    CompanyId: 'COMPA6CCE99B',
  },
  {
    UpdatedAt: '2025-05-07T21:00:44.713Z',
    AccountsDueDate: '2027-02-07',
    RegisteredAddress: {
      country: 'United Kingdom',
      isPublic: true,
      city: 'Redhill',
      street: 'Flat 5, 93 Station Road',
      postalCode: 'RH11DW',
    },
    CompanyNumber: 'COMP861F37C3',
    Status: 'ACTIVE',
    Tax: {
      corporationTaxRegistered: false,
      vatRegistered: false,
      payeRegistered: false,
    },
    ComplianceTimeline: [
      {
        due: '2026-05-07',
        penalty: '£250 to £1,500 if late',
        description: 'Annual statement confirming company details',
        legalRequirement: true,
        id: 'a94d4ef2-3be3-4747-8d08-a62be4170cdb',
        title: 'File Confirmation Statement (CS01)',
        category: 'legal',
        priority: 'high',
        status: 'pending',
      },
      {
        due: '2027-02-07',
        penalty: '£150 to £1,500 if late',
        description: 'First accounts due 21 months after incorporation',
        legalRequirement: true,
        id: '86236d70-8467-46c6-a85f-d1dfd59f9ffb',
        title: 'File First Accounts (AA01)',
        category: 'financial',
        priority: 'high',
        status: 'pending',
      },
      {
        due: 'Not started trading',
        penalty: 'Potential fines + backdated tax',
        description:
          'Must register within 3 months of starting business activity',
        legalRequirement: true,
        id: '11aa71d1-3137-4f76-9be4-c207d534d3f6',
        title: 'Register for Corporation Tax (CT41G)',
        category: 'tax',
        priority: 'high',
        status: 'not-applicable',
      },
      {
        due: '',
        penalty: 'Fines + backdated VAT if late',
        description: 'Required if taxable turnover exceeds £90,000',
        legalRequirement: false,
        id: '92b4b1bc-4b99-4827-acd2-abbe5930e5c9',
        title: 'VAT Registration',
        category: 'tax',
        priority: 'conditional',
        status: 'not-applicable',
      },
      {
        due: '',
        penalty: 'Fines if late',
        description: 'Required if employing staff or paying directors',
        legalRequirement: false,
        id: '531ff697-5033-447f-b611-915bf0db7f1a',
        title: 'PAYE Registration',
        category: 'payroll',
        priority: 'conditional',
        status: 'not-applicable',
      },
    ],
    CompanyName: 'TestMicrosoft LTD',
    IncorporationDate: '2025-05-07',
    ConfirmationDueDate: '2026-05-07',
    CompanyType: 'Private Limited Company',
    ShareStructure: {
      shareClasses: [
        {
          currency: 'GBP',
          votingRights: true,
          type: 'ordinary',
          valuePerShare: 1,
          totalShares: 100,
        },
      ],
      statementOfCapital: {
        totalAmount: 100,
        totalShares: 100,
      },
    },
    Officers: {
      secretaries: [],
      directors: [
        {
          role: 'director',
          address: {
            country: 'United Kingdom',
            isPublic: false,
            city: 'Redhill',
            street: 'Flat 5, 93 Station Road',
            postalCode: 'RH11DW',
          },
          nationality: 'Indian',
          name: 'Joshy',
          serviceAddress: 'same',
          dateOfBirth: '1988-07-01',
          id: 'dir_ef22dc04-4b88-42a5-acd4-066b3ce99df9',
          appointedOn: '2025-05-07',
        },
      ],
    },
    CreatedAt: '2025-05-07T21:00:44.713Z',
    SICCodes: ['01120'],
    UserId: 'c6c2f254-c0e1-706c-10c1-bff0cf3c9761',
    CompanyId: 'COMP861F37C3',
  },
];

const dummyUsers = [
  {
    username: 'e6429264-a051-7038-ccb5-aa02b1c15362',
    email: 'jian.jhn@gmail.com',
    name: 'Jina Thottam',
    phone: '+447576091514',
    enabled: true,
    status: 'CONFIRMED',
    created: '2025-05-17T10:12:55.380Z',
    groups: [
      {
        name: 'User',
        created: '2025-04-14T16:25:53.261Z',
        modified: '2025-04-14T16:25:53.261Z',
      },
    ],
  },
  {
    username: '66a242e4-4021-70b1-28b2-376636391fd4',
    email: 'tessa.kiran@gmail.com',
    name: 'Tessa Kiran',
    phone: '+447576091514',
    enabled: true,
    status: 'CONFIRMED',
    created: '2025-05-17T10:13:56.718Z',
    groups: [
      {
        name: 'User',
        created: '2025-04-14T16:25:53.261Z',
        modified: '2025-04-14T16:25:53.261Z',
      },
    ],
  },
  {
    username: 'f612b2c4-90c1-704b-c6df-3fe176627c40',
    email: 'saneshmat@gmail.com',
    name: 'Sanesh Baby',
    phone: '+447576091514',
    enabled: true,
    status: 'CONFIRMED',
    created: '2025-04-14T21:54:22.264Z',
    groups: [
      {
        name: 'Admin',
        created: '2025-04-14T16:25:48.583Z',
        modified: '2025-04-14T16:25:48.583Z',
      },
    ],
  },
  {
    username: '968272b4-a0c1-701f-4bc6-9feb8a3e00c8',
    email: 'kiranjoshy123@gmail.com',
    name: 'Kiran Joshy',
    phone: '+447880775205',
    enabled: true,
    status: 'CONFIRMED',
    created: '2025-04-14T21:52:53.698Z',
    groups: [
      {
        name: 'Admin',
        created: '2025-04-14T16:25:48.583Z',
        modified: '2025-04-14T16:25:48.583Z',
      },
    ],
  },
  {
    username: 'f68292d4-3001-7099-a902-73897b997f65',
    email: 'kevin.kiran@gmail.com',
    name: 'Kevin Kiran',
    phone: '+447576091514',
    enabled: true,
    status: 'CONFIRMED',
    created: '2025-04-17T10:14:08.126Z',
    groups: [
      {
        name: 'User',
        created: '2025-04-14T16:25:53.261Z',
        modified: '2025-04-14T16:25:53.261Z',
      },
    ],
  },
];

const dummyStats = {
  totalUsers: 1243,
  newUsers: 42,
  totalCompanies: 876,
  pendingApprovals: 23,
  pendingDocuments: 17,
  revenue: 52480,
};

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState(dummyUsers);
  const [companies, setCompanies] = useState(dummyCompanies);
  const [stats, setStats] = useState(dummyStats);
  const [loading, setLoading] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [anchorElMap, setAnchorElMap] = useState({});
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [lastKey, setLastKey] = useState(null);
  const [prevKeys, setPrevKeys] = useState([]);
  const isMobile = useMediaQuery('(max-width:600px)');

  const updateCompanyWithUserNames = () => {
    const updatedCompanies = companies.map((company) => {
      const user = users.find((u) => u.username === company.UserId);
      return {
        ...company,
        userName: user ? user.name : 'Unknown User',
      };
    });
    setCompanies(updatedCompanies);
  };

  const updateStats = () => {
    const now = new Date();
    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);

    setStats({
      ...stats,
      totalCompanies: companies.length,
      totalUsers: users.length,
      newUsers: users.filter((user) => {
        const createdDate = new Date(user.created);
        return createdDate >= startOfMonth;
      }).length,
      newCompanies: companies.filter((company) => {
        const createdDate = new Date(company.CreatedAt);
        return createdDate >= startOfMonth;
      }).length,
    });
  };

  useEffect(() => {
    // if (!isAuthenticated()) {
    //   navigate('/login');
    //   return;
    // }

    // const fetchData = async () => {
    //   try {
    //     setLoading(true);
    //     const [usersData, companiesData] = await Promise.all([
    //       getUsers(),
    //       getAllCompanies(),
    //     ]);

    //     setUsers(usersData.data || []);
    //     setCompanies(companiesData.data || []);
    //     setLastKey(companiesData.lastKey || null);
    //   } catch (err) {
    //     console.error('Failed to fetch data:', err);
    //     if (err.response?.status === 401) {
    //       navigate('/login');
    //     }
    //   } finally {
    //     setLoading(false);
    //   }
    // };

    // fetchData();
    updateCompanyWithUserNames();
    updateStats();
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleMenuClick = (event, companyId) => {
    setAnchorElMap((prev) => ({ ...prev, [companyId]: event.currentTarget }));
  };

  const handleMenuClose = (companyId) => {
    setAnchorElMap((prev) => ({ ...prev, [companyId]: null }));
  };

  const handleNextPage = async () => {
    try {
      setLoading(true);
      const data = await getAllCompanies(lastKey);
      setCompanies(data.data);
      setLastKey(data.lastKey);
      if (lastKey) setPrevKeys((prev) => [...prev, lastKey]);
    } catch (err) {
      console.error('Failed to fetch companies:', err);
    } finally {
      setLoading(false);
    }
  };

  const handlePrevPage = async () => {
    const keys = [...prevKeys];
    keys.pop(); // Remove current lastKey
    const prevKey = keys.pop() || null;
    setPrevKeys(keys);

    try {
      setLoading(true);
      const data = await getAllCompanies(prevKey);
      setCompanies(data.data);
      setLastKey(prevKey);
    } catch (err) {
      console.error('Failed to fetch companies:', err);
    } finally {
      setLoading(false);
    }
  };

  const getStatusChip = (status) => {
    switch (status?.toLowerCase()) {
      case 'approved':
      case 'active':
        return (
          <Chip
            icon={<CheckCircle />}
            label={status}
            color="success"
            size="small"
            variant="outlined"
          />
        );
      case 'pending':
        return (
          <Chip
            icon={<Pending />}
            label={status}
            color="warning"
            size="small"
            variant="outlined"
          />
        );
      case 'rejected':
      case 'suspended':
        return (
          <Chip
            icon={<Warning />}
            label={status}
            color="error"
            size="small"
            variant="outlined"
          />
        );
      default:
        return <Chip label={status} size="small" variant="outlined" />;
    }
  };

  const formatDate = (dateString) => {
    if (!dateString || dateString === 'Not started trading') return 'N/A';
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  const filteredCompanies = companies.filter(
    (company) =>
      company.CompanyName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      company.userId?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 4,
        }}
      >
        <Typography variant="h4" component="div" gutterBottom>
          Admin Dashboard
        </Typography>
        <Box>
          <Tooltip title="Settings">
            <IconButton color="primary" onClick={() => navigate('/settings')}>
              <Settings />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      {/* Stats Cards - Responsive Grid */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {[
          {
            title: 'Total Users',
            value: stats.totalUsers,
            icon: <People color="primary" />,
            subtext: `+${stats.newUsers} new`,
          },
          {
            title: 'Total Companies',
            value: stats.totalCompanies,
            icon: <Business color="primary" />,
            subtext: `+${stats.newCompanies} new`,
          },
          {
            title: 'Pending Approvals',
            value: stats.pendingApprovals,
            icon: <Pending color="warning" />,
            subtext: 'Needs attention',
          },
          {
            title: 'Pending Documents',
            value: stats.pendingDocuments,
            icon: <Description color="warning" />,
            subtext: 'To review',
          },
          {
            title: 'Total Revenue',
            value: `£${stats.revenue.toLocaleString()}`,
            icon: <Payment color="primary" />,
            subtext: 'This month',
          },
        ].map((stat, index) => (
          <Grid item xs={12} sm={6} md={4} lg={2.4} key={index}>
            <Card elevation={3} sx={{ height: '100%' }}>
              <CardContent>
                <Typography variant="subtitle2" color="text.secondary">
                  {stat.title}
                </Typography>
                <Typography variant="h4">{stat.value}</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                  {stat.icon}
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ ml: 1 }}
                  >
                    {stat.subtext}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Main Content */}
      <Card elevation={3}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            variant="scrollable"
          >
            <Tab
              label="Company Management"
              icon={<Business />}
              iconPosition="start"
            />
            <Tab
              label="Documents"
              icon={<Description />}
              iconPosition="start"
            />
            <Tab label="Payments" icon={<Payment />} iconPosition="start" />
            <Tab label="Reports" icon={<BarChart />} iconPosition="start" />
          </Tabs>
        </Box>

        {/* Tab Content */}
        <Box sx={{ p: 3 }}>
          {tabValue === 0 && (
            <>
              <Box
                sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}
              >
                <TextField
                  size="small"
                  placeholder="Search companies or users..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ width: isMobile ? '100%' : 400 }}
                />
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Button
                    variant="outlined"
                    startIcon={<ArrowBack />}
                    onClick={handlePrevPage}
                    disabled={prevKeys.length === 0}
                  >
                    Previous
                  </Button>
                  <Button
                    variant="outlined"
                    endIcon={<ArrowForward />}
                    onClick={handleNextPage}
                    disabled={!lastKey}
                  >
                    Next
                  </Button>
                </Box>
              </Box>

              {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                  <CircularProgress />
                </Box>
              ) : (
                <TableContainer component={Paper}>
                  <Table size={isMobile ? 'small' : 'medium'}>
                    <TableHead>
                      <TableRow>
                        <TableCell>Company</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Registered</TableCell>
                        <TableCell>Owner</TableCell>
                        <TableCell align="right">Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredCompanies.length > 0 ? (
                        filteredCompanies.map((company) => (
                          <TableRow
                            key={company.CompanyId}
                            hover
                            onClick={() => setSelectedCompany(company)}
                            sx={{ cursor: 'pointer' }}
                          >
                            <TableCell>
                              <Typography fontWeight="bold">
                                {company.CompanyName}
                              </Typography>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                {company.CompanyNumber}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              {getStatusChip(company.Status)}
                            </TableCell>
                            <TableCell>
                              {formatDate(company.IncorporationDate)}
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{ display: 'flex', alignItems: 'center' }}
                              >
                                <Avatar sx={{ width: 32, height: 32, mr: 1.5 }}>
                                  <AccountCircle />
                                </Avatar>
                                <Box>
                                  <Typography>{company.userName}</Typography>
                                </Box>
                              </Box>
                            </TableCell>
                            <TableCell align="right">
                              <IconButton
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleMenuClick(e, company.CompanyNumber);
                                }}
                              >
                                <MoreVert />
                              </IconButton>
                              <Menu
                                anchorEl={anchorElMap[company.CompanyNumber]}
                                open={Boolean(
                                  anchorElMap[company.CompanyNumber]
                                )}
                                onClose={() =>
                                  handleMenuClose(company.CompanyNumber)
                                }
                              >
                                <MenuItem
                                  onClick={() => {
                                    setSelectedCompany(company);
                                    handleMenuClose(company.CompanyNumber);
                                  }}
                                >
                                  View Details
                                </MenuItem>
                                <MenuItem onClick={handleMenuClose} disabled>
                                  Edit Company
                                </MenuItem>
                                <MenuItem onClick={handleMenuClose} disabled>
                                  Contact Owner
                                </MenuItem>
                                <Divider />
                                {company.Status === 'PENDING' && (
                                  <>
                                    <MenuItem
                                      onClick={handleMenuClose}
                                      disabled
                                    >
                                      Approve
                                    </MenuItem>
                                    <MenuItem
                                      onClick={handleMenuClose}
                                      disabled
                                    >
                                      Reject
                                    </MenuItem>
                                  </>
                                )}
                                {company.Status === 'ACTIVE' && (
                                  <MenuItem onClick={handleMenuClose} disabled>
                                    Suspend
                                  </MenuItem>
                                )}
                              </Menu>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                            <Typography color="text.secondary">
                              No companies found
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </>
          )}
          {tabValue === 1 && (
            <Box textAlign="center" py={4}>
              <Description
                sx={{ fontSize: 60, color: 'text.disabled', mb: 2 }}
              />
              <Typography variant="h6">Document Verification</Typography>
              <Typography color="text.secondary">
                {stats.pendingDocuments} documents awaiting review
              </Typography>
            </Box>
          )}

          {tabValue === 2 && (
            <Box textAlign="center" py={4}>
              <Receipt sx={{ fontSize: 60, color: 'text.disabled', mb: 2 }} />
              <Typography variant="h6">Payment History</Typography>
              <Typography color="text.secondary">
                £{stats.revenue.toLocaleString()} processed this month
              </Typography>
            </Box>
          )}

          {tabValue === 3 && (
            <Box textAlign="center" py={4}>
              <BarChart sx={{ fontSize: 60, color: 'text.disabled', mb: 2 }} />
              <Typography variant="h6">Reports & Analytics</Typography>
              <Typography color="text.secondary">
                Generate system reports and view analytics
              </Typography>
            </Box>
          )}
        </Box>
      </Card>

      <CompanyDetailDialog
        company={selectedCompany}
        open={Boolean(selectedCompany)}
        onClose={() => setSelectedCompany(null)}
      />
    </Container>
  );
};

export default AdminDashboard;
